import React from 'react';
import Title from '../title/title.js';
import modules_9325e332 from './status_indicator.module.scss.js';
import classNames from '../../classnames.js';

const StatusIndicator = ({ status = "offline", size = "default", rounded, width, height, loading }) => {
    const renderStatusIndicatorText = () => {
        if (size !== "big")
            return null;
        const statusText = status.charAt(0).toUpperCase() + status.slice(1);
        return React.createElement(Title, { fontStyle: "content-medium", bold: true }, statusText);
    };
    const getStatusIndicatorContentClassName = () => classNames(modules_9325e332[`status-indicator-${status}-${size}`], {
        [modules_9325e332["skeleton"]]: loading
    });
    if (rounded) {
        return React.createElement("div", { className: getStatusIndicatorContentClassName(), style: { width: width, height: height } });
    }
    return (React.createElement("div", { className: modules_9325e332["status-indicator-container"], "data-testid": "mbw-status-indicator-container" },
        React.createElement("div", { className: classNames(modules_9325e332["status-indicator-holder"], modules_9325e332[size]) },
            React.createElement("div", { className: getStatusIndicatorContentClassName(), "data-testid": "mbw-status-indicator-content" }, renderStatusIndicatorText()))));
};

export { StatusIndicator as default };
//# sourceMappingURL=status_indicator.js.map
